import { render, staticRenderFns } from "./ChannelDistributionLayout.vue?vue&type=template&id=184b5611&scoped=true&"
import script from "./ChannelDistributionLayout.vue?vue&type=script&lang=ts&"
export * from "./ChannelDistributionLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelDistributionLayout.vue?vue&type=style&index=0&id=184b5611&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b5611",
  null
  
)

export default component.exports